export default "__VITE_ASSET__8f_1Zn5x__"